<template>
    <div class="contents">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="breadcrumb-main user-member justify-content-sm-between">
                        <div class="d-flex flex-wrap justify-content-center breadcrumb-main__wrapper">
                            <div class="d-flex align-items-center user-member__title justify-content-center mr-sm-25">
                                <h4 class="text-capitalize fw-500 breadcrumb-title">
                                    List Node Server
                                </h4>
                            </div>
                        </div>
                        <div class="action-btn">
                            <a v-on:click="toggleModal('new_node_server')" class="btn px-15 btn-primary text-white"
                                style="display: inline-flex; margin: 5px">
                                <i class="fas fa-plus fs-16"></i>
                                Tambah Node Server
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <div class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
                        <NodeServerTable/>
                    </div>
                </div>
            </div>
            <modal name="new_node_server" :height="'auto'" :adaptive="true" :scrollable="true">
                <div style="margin: 20px">
                    <AddNodeServer :defaultValue="editData"/>
                </div>
            </modal>
        </div>
    </div>
</template>

<script>
    import NodeServerTable from "@/components/tables/NodeServer.vue";
    import AddNodeServer from "@/components/forms/node-server/Add.vue";

    export default {
        components: {
            NodeServerTable,
            AddNodeServer
        },
        data() {
            return {
                editData: null
            };
        },
        beforeDestroy(){
            this.$root.$off("toggle_modal", this.fnToggleModal);
        },
        mounted() {
            this.fnToggleModal = (param) => {
                this.toggleModal(param);
            }
            this.$root.$on("toggle_modal", this.fnToggleModal);
        },
        methods: {
            toggleModal(param) {
                if (param === 'new_node_server') {
                    this.editData = null;
                }
                this.$modal.toggle(param);
            },
        },
    };
</script>



